import { AxiosResponse } from "axios";
import { axiosInstance } from "../../../../../services";

const successfulButtonIds = new Set<string>();

export async function handleButtonClick(event: any): Promise<void> {
  event.preventDefault();
  
  const button = event.target as HTMLButtonElement;
  const buttonId = button.id;
  
  // If this button has already been successfully processed, do nothing
  if (successfulButtonIds.has(buttonId)) {
    console.log(`Button ${buttonId} already processed successfully`);
    return;
  }
  
  // If button is already disabled, do nothing
  if (button.disabled) {
    console.log(`Button ${buttonId} is already disabled`);
    return;
  }
  
  const service = button.dataset.service;
  const successMessage = button.dataset.successMessage;
  const errorMessage = button.dataset.errorMessage;
  const responseMessageId = button.dataset.responseMessageId;
  
  // Disable the button immediately to prevent double-clicks
  button.disabled = true;
  
  // Function to re-enable the button
  const reEnableButton = () => {
    const freshButton = document.getElementById(buttonId) as HTMLButtonElement;
    if (freshButton) {
      freshButton.disabled = false;
    } else {
      // Fallback to the original reference
      button.disabled = false;
    }
  };
  
  // Function to mark button as successfully processed
  const markButtonSuccessful = () => {
    successfulButtonIds.add(buttonId);
    
    // Try to get a fresh reference to the button
    const freshButton = document.getElementById(buttonId) as HTMLButtonElement;
    if (freshButton) {
      freshButton.disabled = true;
      freshButton.style.backgroundColor = "#e5e7eb";
      freshButton.setAttribute("data-button-state", "true");
    } else {
      // Fallback to the original reference
      button.disabled = true;
      button.style.backgroundColor = "#e5e7eb";
      button.setAttribute("data-button-state", "true");
    }
  };

  // Get the response message element
  const responseMessageElement = responseMessageId 
    ? document.getElementById(responseMessageId)
    : null;

  try {
    let response: AxiosResponse;
    
    if (service === "webhook") {
      const webhookUrl = button.dataset.url;
      response = await axiosInstance.post("/users/button-click", {
        webhookUrl,
      });
    } else {
      response = await axiosInstance.post("/users/new-button-click", {
        service
      });
    }
    
    if (response.status === 201) {
      // Update success message
      if (responseMessageElement) {
        responseMessageElement.style.display = "block";
        responseMessageElement.style.color = "#048273";
        responseMessageElement.textContent = successMessage || "Success";
      }
      
      // Mark button as successfully processed
      markButtonSuccessful();
    } else {
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (error) {
    console.error("Request error:", error);
    
    // Show error message
    if (responseMessageElement) {
      responseMessageElement.style.display = "block";
      responseMessageElement.style.color = "#C41429";
      responseMessageElement.textContent = errorMessage || "Error";
    }
    
    // Re-enable the button
    reEnableButton();
  }
}

// Export a function to check if a button has been successfully processed
export function hasButtonBeenProcessed(buttonId: string): boolean {
  return successfulButtonIds.has(buttonId);
}